export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 80,
    visible: !that.disabled,
    showHeaderOverflow: true,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_displayImage') || '图片',
    field: 'displayImage',
    width: 80,
    align: 'center',
    fixed: 'left',
    slots: { default: 'displayImage' },
    treeNode: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displayProductName') || '产品名称',
    field: 'displayProductName',
    minWidth: 250,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayProductName' },
  },
  {
    title: that.$l('table_label_displaySpecColor') || '规格颜色',
    field: 'displaySpecColor',
    minWidth: 140,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displaySpecColor' },
  },
  {
    title: that.$l('table_label_displayProductNo') || '产品编号',
    field: 'displayProductNo',
    minWidth: 190,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayProductNo' },
  },
  {
    title: that.$l('table_label_displayProductUnit') || '产品单位入数',
    field: 'displayProductUnit',
    minWidth: 120,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayProductUnit' },
  },
  {
    title: that.$l('table_label_displayCartonType') || '包装纸箱',
    field: 'displayCartonType',
    minWidth: 120,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayCartonType' },
  },
  {
    title: that.$l('table_label_packingType') || '装箱方式',
    field: 'v_packingType',
    minWidth: 120,
    align: 'left',
    showHeaderOverflow: true,
    formatter: ({ row }) => {
      const { v_packingType, parentRowKey } = row
      if (parentRowKey) return ''
      return v_packingType || ''
    },
  },
  {
    title: that.$l('table_label_ctnInPalletQty') || '入托箱数',
    field: 'ctnInPalletQty',
    align: 'center',
    width: 120,
    isTotalColumn: true,
    showHeaderOverflow: true,
    editRender: { enabled: true },
    slots: { edit: 'ctnInPalletQtyInput' },
    formatter: ({ row }) => {
      const { ctnInPalletQty, parentRowKey } = row
      if (parentRowKey) return ''
      return ctnInPalletQty
    },
  },
  {
    title: that.$l('table_label_unitInPalletQty') || '入托产品数量',
    field: 'unitInPalletQty',
    minWidth: 120,
    align: 'center',
    isTotalColumn: true,
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_specInPalletQty') || '入托产品规格数量',
    field: 'specInPalletQty',
    minWidth: 130,
    align: 'center',
    isTotalColumn: true,
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_unitInContainerQty') || '总产品数量',
    field: 'unitInContainerQty',
    minWidth: 120,
    align: 'center',
    isTotalColumn: true,
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_specInContainerQty') || '总规格数量',
    field: 'specInContainerQty',
    minWidth: 120,
    align: 'center',
    isTotalColumn: true,
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
]
